<template>
  <Main>
    <infoForm ref="infoForm" fromType="login" @on-submit="submitHandle" submit="登录" align="注册" align2="忘记密码"
      @on-align="onAlign">
      <div class="loginBtn" slot="loginBtn"></div>
    </infoForm>
  </Main>
</template>

<script>
import util from "@/utils";
import infoForm from "@/components/infoForm/index.vue";
import cookie from "@/utils/cookie.js";
import { getDoctorToken, getDoctorInformation, getDoctorCaptcha } from "@/api";
import Main from "@/components/main/main.vue";
import { createSocket } from "@/utils/WebSocket.js";
import { encryptData } from '@/utils/aes.js' 

export default {
  components: {
    infoForm,
    Main,
  },
  props: {},
  data() {
    return {
      username: "",
      icp_number: process.env.VUE_APP_ICP_NUMBER,
      websiteTitle: process.env.VUE_APP_WEBSITE_TITLE,
      activeName: 1,

      getSocketData: null,
      url: "wss://" + process.env.VUE_APP_BASE + "/server/status",
    };
  },
  mounted() {
    this.logoutUser();
    setTimeout(() => {
      // 自动登录
      if (this.$route.query.imAccid && this.$route.query.imToken) {
        util.setStore("user_token", this.$route.query.token);
        util.setStore("user_id", this.$route.query.doctorId);
        util.setStore("userType", "2"); //医生
        util.setStore("isLogin", true);
        cookie.setCookie("uid", this.$route.query.imAccid);
        cookie.setCookie("sdktoken", this.$route.query.imToken);
        this.getDoctorInfo();
        this.init();

        setTimeout(() => {
          // 提交sdk连接请求
          this.$store.dispatch("connect");
          this.$store.dispatch("resetCurrSession");
          this.$store.dispatch("updateRefreshState");
          //下个版本打开
          this.$router.replace({ path: "/index/work/consultation", query: { imAccid: this.$route.query.imAccid, imToken: this.$route.query.imToken } });
        }, 1500);
      }
    }, 1000)
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    onAlign(type) {
      if (type === "1") {
        this.go("/register");
      } else if (type === "2") {
        this.go("/forget");
      }
    },
    go(url) {
      this.$router.replace({
        path: url,
      });
    },
    /**
     * 登录
     */
    async submitHandle(userInfo) {
      try {
        this.username = userInfo.username;
        let res;
        const { username, loginCaptcha, password, imgCaptcha } = userInfo;
        if (loginCaptcha) {
          //验证码登录
          const params = {
            mobile: username,
            captcha: loginCaptcha,
          };
          res = await useCaptchaLogin(params);
        } else {
          const passwordAes = encryptData(userInfo.password, userInfo.salt)
          const data = { 
            "username": userInfo.username,
            "password": passwordAes,
            "captcha": userInfo.imgCaptcha,
            "checkKey": userInfo.checkKey,
          };
          res = await getDoctorToken(data);
        }
        if (res.code == 1) {
          util.setStore("user_token", res.data.token);
          util.setStore("user_id", res.data.doctorId);
          util.setStore("userType", "2"); //医生
          util.setStore("isLogin", true);
          util.setStore("user_mobile", userInfo.username);
          cookie.setCookie("uid", res.data.imAccid);
          cookie.setCookie("sdktoken", res.data.imToken);
          this.$message({
            showClose: true,
            message: "登录成功",
            type: "success",
          });
          this.getDoctorInfo();
          this.init();
          //下个版本打开
          setTimeout(() => {
            this.$router.replace({ path: "/index/work/consultation" });
          }, 1500);
          // 提交sdk连接请求
          this.$store.dispatch("connect");
          this.$store.dispatch("updateRefreshState");
        } else {
          this.$refs.infoForm.handleChangeCheckCode();
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getDoctorInfo() {
      try {
        let { code, data } = await getDoctorInformation();
        if (code === 1) {
          this.$store.commit("setProfileStep", data.profileStep);
          this.$store.commit("setStatus", data.status);
          util.setStore("username", data.familyName + data.firstName);
          util.setStore("userInfo", data);
        }
      } catch (error) { }
    },
    init() {
      //页面初始化的时候开启WebSocket
      createSocket(this.url);
      // // 创建接收消息函数
      // this.getSocketData = (e) => {
      //   console.log(e);
      //   const data = e && e.detail.data;
      //   //这边编写处理服务端消息代码
      // };
      // //注册监听事件
      // window.addEventListener("onmessageWS", this.getSocketData);
    },
    loginSuccess() {
      util.setStore("user_token", this.$route.query.token);
      util.setStore("user_id", this.$route.query.doctorId);
      util.setStore("userType", "2"); //医生
      util.setStore("isLogin", true);
      cookie.setCookie("uid", this.$route.query.imAccid);
      cookie.setCookie("sdktoken", this.$route.query.imToken);

      this.getDoctorInfo();
      this.init();

      // 提交sdk连接请求
      this.$store.dispatch("connect");
      this.$store.dispatch("resetCurrSession");
      this.$store.dispatch("updateRefreshState");
      setTimeout(() => {
        //下个版本打开
        this.$router.replace({ path: "/index/work/consultation", query: { imAccid: this.$route.query.imAccid, imToken: this.$route.query.imToken } });
      }, 1500);

    },
    logoutUser() {
      // 退出
      util.removeStore("user_token");
      util.removeStore("username");
      util.removeStore("userInfo");
      util.removeStore("user_id");
      util.removeStore("userType");
      util.removeStore("user_mobile");
      util.clearStorage();
      cookie.delCookie("uid");
      cookie.delCookie("sdktoken");
    },
  },
};
</script>

<style lang="scss" scoped>
.loginBtn {
  text-align: end;

  .login-pass {
    font-size: 15px;
    font-weight: 100;
    color: #999999;
  }

  input[type="checkbox"] {
    cursor: pointer;
    position: relative;
    top: 2px;
    right: 6px;
    width: 10px;
    height: 15px;
    font-size: 14px;
  }

  input[type="checkbox"]::after {
    position: absolute;
    top: 0;
    background-color: #fff;
    border: rgb(150, 145, 145) 1px solid;
    color: #f7f2f0;
    width: 15px;
    height: 15px;
    display: inline-block;
    visibility: visible;
    padding-left: 0px;
    text-align: center;
    content: " ";
    border-radius: 3px;
  }

  input[type="checkbox"]:checked::after {
    content: "✓";
    font-size: 12px;
    font-weight: bold;
    background: #fc701a;
    border: #fc701a 1px solid;
  }

  button {
    width: 100%;
    height: 36px;
    margin-bottom: 10px;
  }
}
</style>
